<template>
    <div class="category-goods-div">
        <!--分类商品展示-->
        <div class="category-goods-show"  v-loading="loading">
            <div class="category-goods-container" v-for="(cg,i) in categoryGoods" :key="i" :style="(i+1)%3==0?{marginRight:'0px'}:{marginRight:'10px'}">
                <div class="category-name">
                    <a href="javascript:void(0)" @click="searchByCat(cg.category)"><span>{{cg.category.name}}</span></a>
                    <a href="javascript:void(0)" @click="searchByCat(cg.category)">{{constant.more}}</a>
                </div>

                <div class="goods">
                    <div class = "good" v-for="(good,index) in cg.goods" :key="index">
                        <a href="javascript:void(0)" @click="jumpToDetail(good)"><img :src="good.productImgPath" ></a>
                        <div class="msg">
                           <a @click="jumpToDetail(good)" href="javascript:void(0)" style="text-decoration: none;color:black"> <div class = "name" >{{good.productName}}</div></a>
                            <div class = "supplier">{{good.supplier}}</div>
                            <div class = "price" >{{constant.currencySymbol}}{{good.shopPrice}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--滚动加载事件-->
        <div  v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="300">
           <span :key="scrollNum" v-if="scrollNum<maxScrollNum"></span>
        </div>
    </div>


</template>

<script>
    export default {
        data() {
            let categoryGoodsShow = this.$store.state.malMainPageConfig.categoryGoodsShow
            return {
                busy: false,//是否正在加载过程中
                scrollNum : 1 ,//当前下拉数
                maxScrollNum : categoryGoodsShow.maxScrollNum,//最大下拉数
                constant :  this.$store.state.malMainPageConfig.constant
            }
        },
        computed :{
               categoryGoods : function(){
                    return this.$store.state.malMainPageConfig.categoryGoodsShow.categoryGoods
               } ,
               loading:function(){
                   return this.$store.state.categoryGoodsLoading
               }
        },
    
        methods: {
            loadMore () {
                if(this.scrollNum<this.maxScrollNum){
                    this.busy = true;
                    this.scrollNum++;
                    let param = [];
                    for(var i = 0 ; i<this.categoryGoods.length;i++){
                        param[i]= this.categoryGoods[i].category.id;
                    }
                    this.$api.mainpageApi.categorygoodsShowLoadMore(param).then(response=>{
                        let moreCategoryGoods = response.data.data;
                        var arrLen =  this.categoryGoods.length;
                        for(var i = 0;i<moreCategoryGoods.length;i++){
                            this.categoryGoods[arrLen+i] = moreCategoryGoods[i];
                        }
                        this.busy = false
                    });
                }

            },
            jumpToDetail(product){
                let param = "";
                if(product.source==="1"){
                    param = "&productSelfId="+product.productId;
                }else if(product.source==="2"){
                    param = "&productJdSku="+product.productId;
                }
                param = param + "&opentype=NewWindow";
                const base = window.location.href.split("/isv/")[0];
                let url = base+"/index.html#/dform?&appNumber=pur&formId=mal_productdetail"+param;
                window.open(url,"_blank");
            },
            searchByCat(navItem){
                const base = window.location.href.split("/isv/")[0]
                let url = "";
                if(1==this.$store.state.source){
                    url =base+"/index.html#/dform?formId=mal_search&source=1&searchText="+navItem.longNumber+"&searchFields=[\"catlongnumber\"]&searchShowName="+navItem.name+"&opentype=NewWindow";
                }
                if(2==this.$store.state.source){
                    url =base+"/index.html#/dform?formId=mal_search&source=2&searchText="+navItem.number+"&searchFields=[\"jdcatnumber\"]&searchShowName="+navItem.name+"&opentype=NewWindow&isSearchByJDCatNum=1";
                }
                
                window.open(url,"_blank");
            }

        }
    }
</script>

<style  lang="scss">
    .category-goods-div{
        display: flex;
        justify-content: flex-start;
        width: 100%;
        flex-direction: column;
        align-items: center;
        margin-top: 10px
    }
    .category-goods-show{
        width: 1200px;
         min-height: 450px;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap
    }
    .category-goods-container{
        width: 393px;
        height: 440px;
        background: white;
        margin-right: 10px;
        margin-top: 10px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
    }
    .category-name{
        height: 76px;
        display: flex;
        justify-content: space-between;
        padding: 0 30px 0 30px;
        align-items: center;
    }
    .category-name span{
        font-family: PingFangSC-Regular;
        font-size: 22px;
        color: #333333;
        line-height: 16px;
    }
    .category-name a{
        text-decoration: none;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #5E80EB;
        line-height: 16px;
    }
    .goods{
        height: 345px;
        padding: 0 30px 0 30px;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        overflow: hidden;
    }
    .goods .good{
        height: 100px;
        margin-bottom: 15px;
        display: flex;
        justify-content: flex-start;
        flex-shrink: 0;
        flex-grow: 0;
    }
    .goods .good img{
        width: 100px;
        height: 100px;
    }
    .goods .good .msg{
        height: 100px;
        width: 215px;
        margin-left: 15px;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: stretch;
    }
    .goods .good .msg .name{
        height: 36px;
        line-height: 18px;
        overflow: hidden;
        margin-bottom: 10px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #333333;
        letter-spacing: 0;
        text-align: left;
    }
    .goods .good .msg .supplier{
        height: 18px;
        line-height: 18px;
        overflow: hidden;
        margin-bottom: 10px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        text-align: left;
    }
    .goods .good .msg .price{
        font-family: PingFangSC-Regular;
        font-size: 18px;
        color: #FC8555;
        letter-spacing: 0;
        line-height: 20px;
    }

   div .el-loading-spinner .el-loading-text {
    color: #FC8555;
    opacity: 0.9;
    margin: 3px 0;
    font-size: 14px;
   }
   div .el-loading-spinner i {
        color: #FC8555;
    }
</style>
